module.exports = __webpack_public_path__ + "static/media/map-marker-lab.a074dfba.svg";